<template>

  <v-layout row>   

    <v-flex xs12 sm12 style="margin-top:80px;">
      <v-card style="background: rgb(234, 233, 233) !important">

        <div class="text-xs-right">
          <v-menu offset-y transition="slide-x-transition">
            <template v-slot:activator="{ on }">
              <v-badge overlap color="red" style="margin: 20px 20px 0px 0px;">
              <template v-slot:badge>
              <span>{{totalExpireItem}}</span>
            </template>
              <v-icon
              large
              color="grey"
              v-on="on"
              >
              notifications
            </v-icon>
          </v-badge>
            </template>
            <v-list two-line>
              <template v-for="(item,index) in expireItem">
              <v-list-tile
                :key="index"
                @click="test(item)"
              >
              <v-list-tile-content>
                <v-list-tile-title>{{item.vehicle_name}}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{ item.model_no }}</v-list-tile-sub-title>
              </v-list-tile-content>
              </v-list-tile>
              <v-divider
                    v-if="index + 1 < expireItem.length"
                    :key="index"
                  ></v-divider>
              </template>
            </v-list>
          </v-menu>
        </div>

        <v-layout row align-center  class="light-blue white--text" style="position: fixed;z-index: 2;width: 100%;top: 0;left: 0;">
          <v-flex               
          xs12
          sm2
          md1
          style="text-align:center"
          >      
          <img aspect-ratio="1" :src="`${FrontendPath}/public/dashboard/dashboard.png`" height="80px">
        </v-flex>

        <v-flex               
        xs9
        sm8
        md10      
        >
        <h3>{{projectInfo}}</h3>        
      </v-flex>

      <v-flex               
      xs3
      sm2
      md1
      >
      <v-spacer></v-spacer>
      <v-btn flat small class="p-0 ml-0 white--text" @click="logout()">
        <img :src="`${FrontendPath}/public/dashboard/log-out.png`" height="25px"> Logout
      </v-btn> 
    </v-flex>
  </v-layout>

<div style="
    font-size: 30px;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
">{{main_menu_list[0]['sub_menu'][0]['role_name']}}</div>

  <v-container grid-list-sm fluid style="background: rgb(234, 233, 233) !important;">

    <v-layout row wrap>

      <v-hover v-for="(val,key) in main_menu_list" :key="key" class="mb-2">
        <v-flex               
        xs12
        sm6
        md2

        v-if="val.dashboard>0"
        align-center
        justify-center
        layout
        text-xs-center            
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 12 : 0}`"
        @click="activeModule(val)" style="cursor: pointer;"
        >          
        <v-badge overlap>

          <v-avatar
          :size="200"
          color="grey lighten-4"
          >
          <img v-if="val.icon_name"  :src="`${FrontendPath}/public/dashboard/${val.icon_name}`"  alt="avatar">
          <img v-else  :src="`${FrontendPath}/public/dashboard/logo.png`" alt="avatar">
        </v-avatar>  
        <template>
          <span class="v-badge__badge2">{{val.menu_name}}</span>
        </template>
      </v-badge>  
    </v-flex>

  </v-hover>
</v-layout>
</v-container>

</v-card>
</v-flex>
</v-layout>

</template>


<script>
import {FrontendPath} from '../../vuex/api'
let UtilService = require("../../services/util.service");
let Encrypted = require("../../services/encrypted");
const commonService = require("../../services/common.service");

export default {
  data () {
    return {
      FrontendPath: FrontendPath,
      userInfo:{
        name:'',
      },
      main_menu_list: [],
      expireItem : [],
      totalExpireItem : '',
      loading : false
    }
  },

  created: function(){
    

    this.userInfo.name = UtilService.getUserName().name; 
    let a = UtilService.getProjectInfo();
    console.log('a = ',  a);
    if (sessionStorage.getItem("auth") == "yes") {
      this.main_menu_list = JSON.parse(Encrypted.base64_decode(localStorage.getItem("roleDetails")));      
      this.$store.commit("SET_USER_ROLE_DATA", this.main_menu_list);
    } else this.main_menu_list = this.getMenuList;

    // Notification function
    commonService.getAllData('vehicle-expire-notification').then(res =>{
  
        let vehicleItem = res.data
        let tempItem = []
        vehicleItem.forEach((c,i,f) => {
          if(c.fit_days <= 30 || c.ins_days <= 30 || c.tax_days <= 30){
             tempItem.push(c)
          }
        })
        this.expireItem = tempItem
        this.totalExpireItem = this.expireItem.length
        this.loading = false
    })

    
  },

  methods:{
    // Notification Details
    test(item){
      let stringifyItem = JSON.stringify(item)
      sessionStorage.setItem("vehicleInfo", stringifyItem); 
      this.$router.push('/administration/vehicle-expiry-details')
    },

    activeModule:function(val){  
      localStorage.setItem("module", val.menu_name);
      this.$store.commit('SET_KEY_VALUE',val.menu_name);
      this.$store.commit('SET_MODULE_NAME',val.menu_name);
      this.$router.push({ path: val.main_route });
      sessionStorage.removeItem("ActiveMenu")
      //location.reload()
      this.menu = false;
    },

    logout: function(){
      this.$router.push({'path': "/security/logout"}) 
    },
  },

  computed: {
      projectInfo(){
        let proInfo = this.$store.getters.GET_PROJECT_INFO;        
        return 'MIS & Accounting Software for '+proInfo.project_name_short;
      },

      getMenuList: function() {
       let getMainMenuList = this.$store.getters.getUserRoleDetails
      
      return this.$store.getters.getUserRoleDetails;
    }
    },

  
};
</script>

<style scoped>
.v-image__image--cover {
    background-size: 210px 180px !important;
}
.v-badge__badge2 {
    color: orange;
    display: flex;
   /* border: 1px solid;*/
   font-weight: bold;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.image{
  align-items: center;border-radius: 50%;display: inline-flex;justify-content: center;position: relative;text-align: center;vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue